import vue from 'vue'
import toastComponent from './message.vue'
import commonstate from '../js/constant.js';
import commonUtils from "../js/workspace/common_util.js";
// 组件构造器，构造出一个 vue组件实例
const ToastConstructor = vue.extend(toastComponent)

function showToast({ text, type, duration , idValue, learnMoreShow ,multCloudShow ,toTaskShow ,toSavedSharesShow}) {
    const toastDom = new ToastConstructor({
        el: document.createElement('div'),
        data() {
            return {
                isShow: true, // 是否显示
                text: text, // 文本内容
                type: type, // 类型
                idValue: idValue,
                learnMoreShow: learnMoreShow,
                multCloudShow: multCloudShow,
                toTaskShow: toTaskShow,
                toSavedSharesShow: toSavedSharesShow,
                duration:duration 
            }
        }
    });
    // 添加节点
    document.getElementById(idValue).appendChild(toastDom.$el);
    //设置报错信息长度
    let dom = toastDom.$refs.exceptionText;
    // let textLength = dom.innerText.length;
    // let languaArr = ['japanese', 'chinese', 'traditionalChinese'];
    // if(learnMoreShow){//如果现实了解更改的按钮
    // if (languaArr.includes(this.$i18n.locale)) {
    //     dom.parentElement.parentElement.parentElement.style.width = textLength * 15+ 200 + 'px';
    // }else if(this.$i18n.locale=='italian'){
    //     dom.parentElement.parentElement.parentElement.style.width = textLength * 7+ 200 + 'px';
    // }else if(this.$i18n.locale=='spanish'){
    //     dom.parentElement.parentElement.parentElement.style.width = textLength * 7 + 200 + 'px';
    // }else if(this.$i18n.locale=='deutsch'){
    //     dom.parentElement.parentElement.parentElement.style.width = textLength * 7 + 220 + 'px';
    // }else if(this.$i18n.locale=='france'){
    //     dom.parentElement.parentElement.parentElement.style.width = textLength * 7 + 200 + 'px';
    // }else if(this.$i18n.locale=='portuguese'){
    //     dom.parentElement.parentElement.parentElement.style.width = textLength * 7 + 200 + 'px';
    // }
    // else {
    //     dom.parentElement.parentElement.parentElement.style.width = textLength * 6 + 205 + 'px';
    // }
    // }else{
    //     if (languaArr.includes(this.$i18n.locale)) {
    //         dom.parentElement.parentElement.parentElement.style.width = textLength * 15 + 200 + 'px';
    //     }else if(this.$i18n.locale=='france'){
    //         dom.parentElement.parentElement.parentElement.style.width = textLength * 7 + 200 + 'px';
    //     }else if(this.$i18n.locale=='deutsch'){
    //         dom.parentElement.parentElement.parentElement.style.width = textLength * 7 + 200 + 'px';
    //     } else {
    //         dom.parentElement.parentElement.parentElement.style.width = textLength * 6 + 200 + 'px';
    //     }
    // } 
    if(!duration){
        duration=4000;
    }
    //若用户盐值或自动登录失效，则退出网站，回到首页
    if (dom.innerText.replace(/^\s+|\s+$/g, "") == toastDom.vm.$t('language.exception.saltInvalid').replace(/^\s+|\s+$/g, "")||
    dom.innerText.replace(/^\s+|\s+$/g, "") == "The salt is invalid".replace(/^\s+|\s+$/g, "")||
    dom.innerText.replace(/^\s+|\s+$/g, "") == toastDom.vm.$t('language.exception.autoLoginFail').replace(/^\s+|\s+$/g, "")) {
        setTimeout(() => {
            var localUser = commonUtils.getUserToLocal();
            var cookieUser = commonUtils.getUserCookies();
            if(cookieUser&&localUser.salt != cookieUser.salt){
                //盐值不同的情况切换账号
                localStorage.removeItem("user");
                toastDom.vm.$store.state.allDrives = [];
                window.location.href = commonstate.nowNewUrl;
            }else{
                //退出登录
                commonUtils.logout_clear();
                toastDom.vm.$store.state.allDrives = [];
                let language = commonUtils.caseIndexLanguage(localStorage.getItem("locale"));
                //分享页下刷新本页面
                if(idValue=="share_page"||idValue=="shareRightContBan"){
                    location.reload();
                }else{
                    window.location.href = commonstate.oldVersionUrl + "/action/userinfo!exitLogin?redirect=" + commonstate.frontEndUrl + (language=="en"?"":"/"+language) + "";
                }
            }
        }, duration);
    }
    // 过渡时间
    if (type != 'loginSuccess') {
        setTimeout(() => {
          toastDom.isShow = false;
        }, duration);
    }
}
// 全局注册
function registryToast() {
    vue.prototype.$toast = showToast;
}

export default registryToast


// WEBPACK FOOTER //
// ./src/messages/messageIndex.js